var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback } from 'react';
import { Actions, SelectStaticWrapper as ComponentWrapper, SelectStatic as Select, LegacySelectPlaceholder, CitronSelectPlaceholder, } from './Select.styled';
import { Input, styles as inputStyles, validationAccessibility, citrus2022Styles as inputStylesCitrus2022, } from '@citrus/input';
import { cx, css as emotionCss } from 'emotion';
import DropdownIcon from './private/subcomponents/DropdownIcon';
import { getAutomation, getDebug } from '@citrus/runtime';
import { useTheme, getThemeStyle } from '@citrus/user';
import { isNotNilOrEmpty, isString } from '@pcty/utils';
var VERSION = '10.2.3';
var SelectStatic = function (_a) {
    var _b, _c;
    var _d, _e;
    var automationId = _a.automationId, className = _a.className, classNameWrapper = _a.classNameWrapper, css = _a.css, cssWrapper = _a.cssWrapper, _f = _a.disabled, disabled = _f === void 0 ? false : _f, errorMessage = _a.errorMessage, footnote = _a.footnote, _g = _a.hideOptionalLabel, hideOptionalLabel = _g === void 0 ? false : _g, id = _a.id, label = _a.label, labelAddOn = _a.labelAddOn, _h = _a.labelPosition, labelPosition = _h === void 0 ? 'top' : _h, options = _a.options, onChange = _a.onChange, placeholder = _a.placeholder, _j = _a.required, required = _j === void 0 ? false : _j, _k = _a.showRequiredLabel, showRequiredLabel = _k === void 0 ? false : _k, _l = _a.showValidationState, showValidationState = _l === void 0 ? false : _l, tabIndex = _a.tabIndex, _m = _a.valid, valid = _m === void 0 ? false : _m, value = _a.value, _o = _a.__TYPE, TYPE = _o === void 0 ? 'SelectStatic' : _o, other = __rest(_a, ["automationId", "className", "classNameWrapper", "css", "cssWrapper", "disabled", "errorMessage", "footnote", "hideOptionalLabel", "id", "label", "labelAddOn", "labelPosition", "options", "onChange", "placeholder", "required", "showRequiredLabel", "showValidationState", "tabIndex", "valid", "value", "__TYPE"]);
    var theme = useTheme();
    var isRequired = isString(required) ? true : required !== null && required !== void 0 ? required : false;
    var placeholderOption = placeholder ? { label: placeholder, value: '' } : null;
    var appliedValue = (_d = value === null || value === void 0 ? void 0 : value.value) !== null && _d !== void 0 ? _d : '';
    var _p = useState(false), isOpen = _p[0], setIsOpen = _p[1];
    var style = useCallback(function (legacy, citrus2022) {
        return getThemeStyle(theme, { legacy: legacy, citrus2022: citrus2022 });
    }, [theme]);
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b), className || '');
    var closeMenu = function () {
        setIsOpen(false);
    };
    var openMenu = function () {
        setIsOpen(true);
    };
    var handleOnBlur = function () {
        setIsOpen(false);
    };
    var handleOnClick = function (e) {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };
    var handleOnKeyDown = function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Space') {
            setIsOpen(!isOpen);
        }
    };
    var placeholderSelected = function () {
        return !!placeholderOption &&
            (!(options === null || options === void 0 ? void 0 : options.length) ||
                !options.some(function (option) { return appliedValue !== placeholderOption.value && appliedValue === option.value; }));
    };
    var errorStyles = style(inputStyles.error, inputStylesCitrus2022.error);
    var disabledStyles = style(inputStyles.disabled, inputStylesCitrus2022.disabled);
    var selectPlaceholder = style(LegacySelectPlaceholder, CitronSelectPlaceholder);
    return (React.createElement(Input, __assign({ automationId: automationId, className: classNameWrapper, css: cssWrapper, disabled: disabled, errorMessage: errorMessage, footnote: footnote, hideOptionalLabel: hideOptionalLabel, id: id, label: label, labelAddOn: labelAddOn, labelPosition: labelPosition, required: isRequired, showRequiredLabel: showRequiredLabel, showValidationState: showValidationState, valid: valid }, other),
        React.createElement(ComponentWrapper, __assign({ className: classes, id: "".concat(id, "-wrapper") }, other, getAutomation(automationId, 'select-static-wrapper'), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION), validationAccessibility(id, valid, showValidationState)),
            React.createElement(Actions, null,
                React.createElement(DropdownIcon, { closeMenu: closeMenu, config: { toggle: false }, disabled: disabled, isOpen: isOpen, openMenu: openMenu })),
            React.createElement(Select, __assign({}, getAutomation(automationId, 'select-static'), { className: cx((_c = {},
                    _c[emotionCss(disabledStyles)] = disabled,
                    _c[emotionCss(selectPlaceholder)] = !disabled && placeholderSelected(),
                    _c[emotionCss(errorStyles)] = !valid && showValidationState,
                    _c)), disabled: disabled, id: id, onBlur: handleOnBlur, onChange: function (e) { return handleOnChange(e, onChange, id); }, onClick: handleOnClick, onKeyDown: handleOnKeyDown, required: isRequired, tabIndex: isNotNilOrEmpty(tabIndex) ? tabIndex : undefined, value: appliedValue }),
                placeholderOption ? renderPlaceholder(placeholderOption.label, (_e = placeholderOption.value) !== null && _e !== void 0 ? _e : '') : null,
                options ? renderOptions(id, options) : null))));
};
var renderPlaceholder = function (placeholder, value) { return (React.createElement("option", { value: value }, placeholder)); };
var renderOptions = function (id, options) {
    return options.map(function (x, i) { return (React.createElement("option", { key: x.value ? "".concat(id, "-").concat(x.value) : "".concat(id, "-").concat(i, "-").concat(x.label), value: x.value }, x.label)); });
};
var handleOnChange = function (e, onChange, id) {
    e.stopPropagation();
    var _a = e.target.options[e.target.selectedIndex], text = _a.text, value = _a.value;
    onChange({ label: text, value: value }, id);
};
SelectStatic.defaultProps = {
    __TYPE: 'SelectStatic',
};
export default SelectStatic;
